var parse=require('../parse/index.js');/**
 * @category Day Helpers
 * @summary Set the day of the month to the given date.
 *
 * @description
 * Set the day of the month to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} dayOfMonth - the day of the month of the new date
 * @returns {Date} the new date with the day of the month setted
 *
 * @example
 * // Set the 30th day of the month to 1 September 2014:
 * var result = setDate(new Date(2014, 8, 1), 30)
 * //=> Tue Sep 30 2014 00:00:00
 */function setDate(dirtyDate,dirtyDayOfMonth){var date=parse(dirtyDate);var dayOfMonth=Number(dirtyDayOfMonth);date.setDate(dayOfMonth);return date;}module.exports=setDate;